import Image from "@/atoms-react/image/Image.react";
import { Base, SectionTitle } from "@/atoms-react/text/Text.react";
import { useTranslation, Trans } from "react-i18next";
import { FormFooter } from "./form-footer.react";

type WelcomeStepProps = {
  onValidated: () => void;
  isNextDisabled?: boolean;
  custom_scenario?: boolean;
};

export const WelcomeStep = ({
  onValidated,
  custom_scenario = false,
  isNextDisabled = false
}: WelcomeStepProps) => {
  const { t } = useTranslation(["atoms"]);
  return (
    <>
      <div className="mx-auto max-w-4xl px-4 py-4 text-center">
        <Image
          className="mx-auto mb-4 h-auto w-60 md:w-80"
          alt={t("molecules.modal_kyc_identity.step1_image_alt")}
          src={"/images/olkypass/informationStep1.png"}
        />
        <div className="mx-auto px-4 text-center">
          <SectionTitle className="mb-4 text-base">
            {t("molecules.modal_kyc_identity.step1_title")}
          </SectionTitle>
          <Base className="font-medium text-gray-400">
            <Trans
              i18nKey={"molecules.modal_kyc_identity.step1_content_new"}
              ns={"atoms"}
              components={{ span: <span className="font-semibold text-primary" /> }}
            />
          </Base>
        </div>
      </div>
      {!custom_scenario && (
        <FormFooter currentStep={0} nextDisabled={isNextDisabled} onNext={onValidated} />
      )}
    </>
  );
};
